module.exports = __webpack_public_path__ + "static/media/va.21913d78.svg";